// import React, { Component } from "react";
// import { Card } from "react-bootstrap";
// import { Helmet } from "react-helmet";
// import { Breadcrumb } from "@gull";
// import { Formik } from "formik";
// import { model, validationModel } from "./EditBankModel";
// import bankService from "app/services/bankService";
// import { RenderCheckboxInput } from "app/common/renderInput";

// const EditBank = ({ editModelValues, handleEditSubmit }) => {
//   return (
//     <div
//       className="modal fade"
//       id="editBankModalforDistributor"
//       tabIndex="-1"
//       role="dialog"
//       aria-labelledby="exampleModalLabel"
//       aria-hidden="true"
//     >
//       <div className="modal-dialog" role="document">
//         <div className="modal-content">
//           <div className="modal-header">
//             <h5 className="modal-title" id="exampleModalLabel">
//               Edit Bank Details
//             </h5>
//             <button
//               type="button"
//               className="close"
//               data-dismiss="modal"
//               aria-label="Close"
//             >
//               <span aria-hidden="true">&times;</span>
//             </button>
//           </div>
//           <div className="modal-body">
//             <Formik
//               initialValues={editModelValues}
//               validationSchema={validationModel}
//               onSubmit={handleEditSubmit}
//               enableReinitialize={true}
//             >
//               {({
//                 values,
//                 errors,
//                 touched,
//                 handleChange,
//                 handleBlur,
//                 handleSubmit,
//                 setFieldValue,
//               }) => {
//                 return (
//                   <form onSubmit={handleSubmit}>
//                     <div
//                       className="row"
//                       style={{ alignItems: "center", paddingLeft: "14px" }}
//                     >
//                       <input
//                         type="text"
//                         name="id"
//                         className="form-control customInput d-none"
//                         placeholder="id"
//                         value={values.id}
//                         error={errors.id}
//                         onChange={handleChange}
//                         onBlur={handleBlur}
//                         touched={touched.id}
//                       />
//                       <p className="text-danger">{touched.id && errors.id}</p>
//                       <div className="col-md-6 col-12">
//                         <div className="form-group">
//                           <label
//                             htmlFor="bankName"
//                             className="font-weight-bold"
//                             style={{ fontSize: "15px" }}
//                           >
//                             Bank Name
//                             <span className="text-danger"> *</span>
//                           </label>
//                           <input
//                             type="text"
//                             name="bankName"
//                             // id='bankName'
//                             className="form-control customInput"
//                             placeholder="Bank Name"
//                             value={values.bankName}
//                             error={errors.bankName}
//                             onChange={handleChange}
//                             onBlur={handleBlur}
//                             touched={touched.bankName}
//                           />
//                           <p className="text-danger">
//                             {touched.bankName && errors.bankName}
//                           </p>
//                         </div>
//                       </div>
//                       <div className="col-md-6 col-12">
//                         <div className="form-group">
//                           <label
//                             htmlFor="accountNumber"
//                             className="font-weight-bold"
//                             style={{ fontSize: "15px" }}
//                           >
//                             A/C Number
//                             <span className="text-danger"> *</span>
//                           </label>
//                           <input
//                             type="text"
//                             name="accountNumber"
//                             className="form-control customInput"
//                             placeholder="Account Number"
//                             value={values.accountNumber}
//                             error={errors.accountNumber}
//                             onChange={handleChange}
//                             onBlur={handleBlur}
//                             touched={touched.accountNumber}
//                           />
//                           <p className="text-danger">
//                             {touched.accountNumber && errors.accountNumber}
//                           </p>
//                         </div>
//                       </div>
//                     </div>

//                     <div
//                       className="row"
//                       style={{ alignItems: "center", paddingLeft: "14px" }}
//                     >
//                       <div className="col-md-6 col-12">
//                         <div className="form-group">
//                           <label
//                             htmlFor="ifscCode"
//                             className="font-weight-bold"
//                             style={{ fontSize: "15px" }}
//                           >
//                             IFSC Code
//                             <span className="text-danger"> *</span>
//                           </label>
//                           <input
//                             type="text"
//                             name="ifscCode"
//                             className="form-control customInput"
//                             placeholder="IFSC Code"
//                             value={values.ifscCode}
//                             error={errors.ifscCode}
//                             onChange={handleChange}
//                             onBlur={handleBlur}
//                             touched={touched.ifscCode}
//                           />
//                           <p className="text-danger">
//                             {touched.ifscCode && errors.ifscCode}
//                           </p>
//                         </div>
//                       </div>
//                       <div className="col-md-6 col-12">
//                         <div className="form-group">
//                           <label
//                             htmlFor="branch"
//                             className="font-weight-bold"
//                             style={{ fontSize: "15px" }}
//                           >
//                             Branch
//                             <span className="text-danger"> *</span>
//                           </label>
//                           <input
//                             type="text"
//                             name="branch"
//                             className="form-control customInput"
//                             placeholder="branch"
//                             value={values.branch}
//                             error={errors.branch}
//                             onChange={handleChange}
//                             onBlur={handleBlur}
//                             touched={touched.branch}
//                           />
//                           <p className="text-danger">
//                             {touched.branch && errors.branch}
//                           </p>
//                         </div>
//                       </div>
//                     </div>

//                     <div
//                       className="row"
//                       style={{ alignItems: "center", paddingLeft: "14px" }}
//                     >
//                       <div className="col-md-6 col-12">
//                         <div className="form-group">
//                           <label
//                             htmlFor="shortCode"
//                             className="font-weight-bold"
//                             style={{ fontSize: "15px" }}
//                           >
//                             Bank Short Code
//                             <span className="text-danger"> *</span>
//                           </label>
//                           <input
//                             type="text"
//                             name="shortCode"
//                             className="form-control customInput"
//                             placeholder="Bank Short Code"
//                             value={values.shortCode}
//                             error={errors.shortCode}
//                             onChange={handleChange}
//                             onBlur={handleBlur}
//                             touched={touched.shortCode}
//                           />
//                           <p className="text-danger">
//                             {touched.shortCode && errors.shortCode}
//                           </p>
//                         </div>
//                       </div>
//                       <div className="col-md-6 col-12">
//                         <div className="form-group">
//                           <label
//                             htmlFor="swiftCode"
//                             className="font-weight-bold"
//                             style={{ fontSize: "15px" }}
//                           >
//                             Swift Code
//                           </label>
//                           <input
//                             type="text"
//                             name="swiftCode"
//                             className="form-control customInput"
//                             placeholder="Swift Code"
//                             value={values.swiftCode}
//                             error={errors.swiftCode}
//                             onChange={handleChange}
//                             onBlur={handleBlur}
//                             touched={touched.swiftCode}
//                           />
//                           <p className="text-danger">
//                             {touched.swiftCode && errors.swiftCode}
//                           </p>
//                         </div>
//                       </div>
//                     </div>
//                     <div
//                       className="row"
//                       style={{ alignItems: "center", paddingLeft: "14px" }}
//                     >
//                       <div className="col-md-6 col-12">
//                         <div className="form-group">
//                           <label
//                             htmlFor="address"
//                             className="font-weight-bold"
//                             style={{ fontSize: "15px" }}
//                           >
//                             Address
//                             <span className="text-danger"> *</span>
//                           </label>
//                           <input
//                             type="text"
//                             name="address"
//                             className="form-control customInput"
//                             placeholder="address"
//                             value={values.address}
//                             error={errors.address}
//                             onChange={handleChange}
//                             onBlur={handleBlur}
//                             touched={touched.address}
//                           />
//                           <p className="text-danger">
//                             {touched.address && errors.address}
//                           </p>
//                         </div>
//                       </div>
//                       <div className="col-md-6 col-12">
//                         <div className="form-group">
//                           <label
//                             htmlFor="remarks"
//                             className="font-weight-bold"
//                             style={{ fontSize: "15px" }}
//                           >
//                             Remarks
//                           </label>
//                           <input
//                             type="text"
//                             name="remarks"
//                             className="form-control customInput"
//                             placeholder="remarks"
//                             value={values.remarks}
//                             error={errors.remarks}
//                             onChange={handleChange}
//                             onBlur={handleBlur}
//                             touched={touched.remarks}
//                           />
//                           <p className="text-danger">
//                             {touched.remarks && errors.remarks}
//                           </p>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="row">
//                       <div className="col-md-6 col-12">
//                         <div className="form-group" style={{paddingLeft:"16%"}}>
//                           <input
//                             className="form-check-input"
//                             type="checkbox"
//                             checked={values.status}
//                             name="status"
//                             value={values.status}
//                             onChange={handleChange}
//                             onBlur={handleBlur}
//                             touched={touched.status}
//                           ></input>
//                           <label
//                             htmlFor="status"
//                             className="font-weight-bold form-check-label"
//                             style={{ fontSize: "15px", paddingLeft: "6%" }}
//                           >
//                             Status
//                           </label>
//                           {/* <RenderCheckboxInput
//                               name="status"

//                               value={values.status}
//                               error={errors.status}
//                               onChange={handleChange}
//                              // onChange={(e) => {
//                             //   setFieldValue(`status`, true);
//                             // }}
//                               onBlur={handleBlur}
//                               touched={touched.status}
//                             ></RenderCheckboxInput> */}

//                           {/* </div> */}
//                         </div>
//                       </div>

//                       <div className="col-12 mt-3 mb-3">
//                         <button type="submit" className="btn btn-primary">
//                           Submit
//                         </button>
//                       </div>
//                     </div>
//                   </form>
//                 );
//               }}
//             </Formik>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default EditBank;
import React, { Component } from "react";
import { Card } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Breadcrumb } from "@gull";
import { Formik } from "formik";
import { model, validationModel } from "./EditBankModel";
import bankService from "app/services/bankService";
import { RenderCheckboxInput } from "app/common/renderInput";

const EditBank = ({ editModelValues, handleEditSubmit }) => {
  return (
    <div
      className="modal fade"
      id="editBankModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              Edit Bank Details
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <Formik
              initialValues={editModelValues}
              validationSchema={validationModel}
              onSubmit={handleEditSubmit}
              enableReinitialize={true}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
              }) => {
                return (
                  <form onSubmit={handleSubmit}>
                    <div className="row" style={{ alignItems: "center" }}>
                      <input
                        type="text"
                        name="id"
                        className="form-control customInput d-none"
                        placeholder="id"
                        value={values.id}
                        error={errors.id}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.id}
                      />
                      <p className="text-danger">{touched.id && errors.id}</p>
                      <div className="col-md-6 col-12">
                        <div className="form-group">
                          <label
                            htmlFor="bankName"
                            className=" fw-bold"
                            style={{ fontSize: "15px" }}
                          >
                            Bank Name
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="bankName"
                            // id='bankName'
                            className="form-control customInput"
                            placeholder="Bank Name"
                            value={values.bankName}
                            error={errors.bankName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.bankName}
                          />
                          <p className="text-danger">
                            {touched.bankName && errors.bankName}
                          </p>
                        </div>
                      </div>
                      <div className="col-md-6 col-12">
                        <div className="form-group">
                          <label
                            htmlFor="accountNumber"
                            className=" fw-bold"
                            style={{ fontSize: "15px" }}
                          >
                            A/C Number
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="accountNumber"
                            className="form-control customInput"
                            placeholder="Account Number"
                            value={values.accountNumber}
                            error={errors.accountNumber}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.accountNumber}
                          />
                          <p className="text-danger">
                            {touched.accountNumber && errors.accountNumber}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="row" style={{ alignItems: "center" }}>
                      <div className="col-md-6 col-12">
                        <div className="form-group">
                          <label
                            htmlFor="ifscCode"
                            className=" fw-bold"
                            style={{ fontSize: "15px" }}
                          >
                            IFSC Code
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="ifscCode"
                            className="form-control customInput"
                            placeholder="IFSC Code"
                            value={values.ifscCode}
                            error={errors.ifscCode}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.ifscCode}
                          />
                          <p className="text-danger">
                            {touched.ifscCode && errors.ifscCode}
                          </p>
                        </div>
                      </div>
                      <div className="col-md-6 col-12">
                        <div className="form-group">
                          <label
                            htmlFor="branch"
                            className=" fw-bold"
                            style={{ fontSize: "15px" }}
                          >
                            Branch
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="branch"
                            className="form-control customInput"
                            placeholder="branch"
                            value={values.branch}
                            error={errors.branch}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.branch}
                          />
                          <p className="text-danger">
                            {touched.branch && errors.branch}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="row" style={{ alignItems: "center" }}>
                      <div className="col-md-6 col-12">
                        <div className="form-group">
                          <label
                            htmlFor="shortCode"
                            className=" fw-bold"
                            style={{ fontSize: "15px" }}
                          >
                            Bank Short Code
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="shortCode"
                            className="form-control customInput"
                            placeholder="Bank Short Code"
                            value={values.shortCode}
                            error={errors.shortCode}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.shortCode}
                          />
                          <p className="text-danger">
                            {touched.shortCode && errors.shortCode}
                          </p>
                        </div>
                      </div>
                      <div className="col-md-6 col-12">
                        <div className="form-group">
                          <label
                            htmlFor="swiftCode"
                            className=" fw-bold"
                            style={{ fontSize: "15px" }}
                          >
                            Swift Code
                          </label>
                          <input
                            type="text"
                            name="swiftCode"
                            className="form-control customInput"
                            placeholder="Swift Code"
                            value={values.swiftCode}
                            error={errors.swiftCode}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.swiftCode}
                          />
                          <p className="text-danger">
                            {touched.swiftCode && errors.swiftCode}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="row" style={{ alignItems: "center" }}>
                      <div className="col-md-6 col-12">
                        <div className="form-group">
                          <label
                            htmlFor="address"
                            className=" fw-bold"
                            style={{ fontSize: "15px" }}
                          >
                            Address
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="address"
                            className="form-control customInput"
                            placeholder="address"
                            value={values.address}
                            error={errors.address}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.address}
                          />
                          <p className="text-danger">
                            {touched.address && errors.address}
                          </p>
                        </div>
                      </div>
                      <div className="col-md-6 col-12">
                        <div className="form-group">
                          <label
                            htmlFor="remarks"
                            className=" fw-bold"
                            style={{ fontSize: "15px" }}
                          >
                            Remarks
                          </label>
                          <input
                            type="text"
                            name="remarks"
                            className="form-control customInput"
                            placeholder="remarks"
                            value={values.remarks}
                            error={errors.remarks}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.remarks}
                          />
                          <p className="text-danger">
                            {touched.remarks && errors.remarks}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 col-12">
                        <div className="form-group">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={values.status}
                            name="status"
                            value={values.status}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.status}
                          ></input>
                          <label
                            htmlFor="status"
                            className=" fw-bold form-check-label"
                            style={{ fontSize: "15px", paddingLeft: "6%" }}
                          >
                            Status
                          </label>
                        </div>
                      </div>

                      <div className="col-12 mt-3 mb-3">
                        <button type="submit" className="btn btn-primary">
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                );
              }}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditBank;
